import './index.scss'
import { Controller as BaseController } from 'stimulus'
import Rails from '@rails/ujs'

export class Controller extends BaseController {
  static targets = ['self', 'titleInput', 'title'];

  static classes = ['editing']

  static values = {
    title: String,
    selfUrl: String,
    titleId: String
  }

  resetValidation() {
    this.titleInputTarget.setCustomValidity('')
  }

  edit() {
    this.selfTarget.classList.add(this.editingClass)
  }

  cancel() {
    this.selfTarget.classList.remove(this.editingClass)
    this.titleInputTarget.value = this.titleValue
    this.resetValidation()
  }

  save() {
    Rails.ajax({
      type: 'PUT',
      url: `${this.selfUrlValue}/header`,
      dataType: 'script',
      data: $.param({
        title: this.titleInputTarget.value,
        header_title_element_id: this.titleIdValue
      }),
      success: () => {
        this.titleValue = this.titleInputTarget.value
        this.selfTarget.classList.remove(this.editingClass)
      },
      error: () => {
        this.titleInputTarget.setCustomValidity('Invalid.')
      }
    })
  }

  delete(e) {
    e.preventDefault()
  }
}
